export default "__VITE_ASSET__Cb0LzUcU__"